export enum OpenId4VcSpecVersion {
    DRAFT13 = 'DRAFT13'
}
